import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyModule } from 'survey-angular-ui';
import { NoResultsMessageModule, SpinnerModule } from '@tangilla/tg-ng-common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaymentFormWidgetComponent } from './payment-form/payment-form.widget.component';
import { registerPaymentFormWidget } from './payment-form/payment-form.widget.model';
import { AddressFormWidgetComponent } from './address-form/address-form.widget.component';
import { OfficeSearchWidgetComponent } from './office-search/office-search.widget.component';
import {
  CorporateStructureOfficeListWidgetComponent
} from './corporate-structure-office-list/corporate-structure-office-list.widget.component';
import { DetailsListWidgetComponent } from './details-list/details-list.widget.component';
import { registerAddressFormWidget } from './address-form/address-form.widget.model';
import { LicenseValidationFormWidgetComponent } from './license-validation/license-validation-form.widget.component';
import { registerLicenseValidationWidget } from './license-validation/license-validation-form.widget.model';
import {
  FormInputQuestionModule
} from '../../../common/components/form-questions/form-input-question/form-input-question.module';
import {
  FormDropdownQuestionModule
} from '../../../common/components/form-questions/form-dropdown-question/form-dropdown-question.module';
import {
  FormControlQuestionProcessorModule
} from '../../../common/components/form-questions/form-control-question-processor/form-control-question-processor.module';
import { RecnIframeModule } from '@tangilla/tg-ng-payments';
import {
  SurveyQuestionErrorModule
} from '../../../common/components/survey-question-error/survey-question-error.module';
import { registerOfficeSearchWidget } from './office-search/office-search.widget.model';
import {
  registerCorporateStructureOfficeListWidget
} from './corporate-structure-office-list/corporate-structure-office-list.widget.model';
import { registerDetailsListWidget } from './details-list/details-list.widget.model';
import { M1SearchFormWidgetComponent } from './m1-search/m1-search-form.widget.component';
import { registerM1SearchFormWidget } from './m1-search/m1-search-form.widget.model';
import {
  FormRadioGroupQuestionModule
} from '../../../common/components/form-questions/form-radio-group-question/form-radio-group-question.module';
import {
  PaymentFormTelecheckWidgetComponent
} from './payment-form/payment-form-telecheck/payment-form-telecheck.widget.component';
import {
  registerPaymentFormTelecheckWidget
} from './payment-form/payment-form-telecheck/payment-form-telecheck.widget.model';
import {
  PaymentFormCreditCardWidgetComponent
} from './payment-form/payment-form-credit-card/payment-form-credit-card.widget.component';
import {
  registerPaymentFormCreditCardWidget
} from './payment-form/payment-form-credit-card/payment-form-credit-card.widget.model';
import { TangillaQuestion } from './tangilla-question';

@NgModule({
  declarations: [
    PaymentFormWidgetComponent,
    PaymentFormTelecheckWidgetComponent,
    PaymentFormCreditCardWidgetComponent,
    LicenseValidationFormWidgetComponent,
    AddressFormWidgetComponent,
    OfficeSearchWidgetComponent,
    CorporateStructureOfficeListWidgetComponent,
    DetailsListWidgetComponent,
    M1SearchFormWidgetComponent,
    TangillaQuestion
  ],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    SurveyModule,
    SpinnerModule,
    NoResultsMessageModule,
    FormsModule,
    FormDropdownQuestionModule,
    FormInputQuestionModule,
    FormDropdownQuestionModule,
    FormControlQuestionProcessorModule,
    RecnIframeModule,
    SurveyQuestionErrorModule,
    FormRadioGroupQuestionModule
  ]
})
export class WidgetsModule {
  constructor() {
    this.registerAllWidgets();
  }

  private registerAllWidgets() {
    registerAddressFormWidget();
    registerPaymentFormTelecheckWidget();
    registerPaymentFormCreditCardWidget();
    registerPaymentFormWidget();
    registerLicenseValidationWidget();
    registerOfficeSearchWidget();
    registerCorporateStructureOfficeListWidget();
    registerDetailsListWidget();
    registerM1SearchFormWidget();
  }

}
